<template>
  <v-card dense elevation="0">
    <v-card-title class="justify-center">{{title}}</v-card-title>
    <v-row>
      <v-col cols="12" v-for="att in atts" v-bind:key="`mc-${att.title}`">
        <MiniCard
            fitmod=       "1"
            :title=       "att.title"
            :value=       "parseValue(att.value)"
            :maxFontSize= "30"/>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
  import MiniCard from './MiniCard'

  export default {
    name:       'MiniCardContainer',
    props:      { title: String, atts: Array },
    components: { MiniCard },
    mounted() {
      this.$redrawVueMasonry()
    },
    methods: {
      parseValue(value) {
        return value === 0 ? '0' : ((value || '').toString().trim().replace(/T\d\d:.*/, '') || this.$t('field.N/A'))
      }
    }
  }
</script>
